import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private networkConnected = new BehaviorSubject<boolean>(true);
  isConnected = this.networkConnected.asObservable();

  constructor() { }

  setNetworkStatus(status: boolean) {
    this.networkConnected.next(status);
  }

}
